import React, { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { BackButton, EditButton } from "../../../../Components/Utils/Buttons";
import { NormalHeading, SmallHeading } from "../../../../Components/Utils/Heading";

import CommonComments from "../../../../Components/Utils/commonComments";
import NuAmount from "../../../../Components/Utils/NuAmount";

import { useFormik } from "formik";
import FilesView from "../../../../Components/Utils/FilesView";
import * as yup from "yup";
import {
  InputCheck,
  
  NuInput,
  NuTextArea,
} from "../../../../Components/Utils/Input";
import NuDateFormat from "../../../../Components/Utils/NuDate";
import { GetAccess } from "../../../../Components/Utils/roles";
import axiosInstance from "../../../../Services/axiosCommon";
import PDFViewer from "../../../../Components/Utils/PDFViewer";
import ApprovalComponent from "../../../../Components/Utils/approvalComponent";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import NuDate from "../../../../Components/Utils/NuDate";
function ViewRenewal(onClose) {
  const { renewalViewId } = useParams();
  const location = useLocation();
  const sData = location.state?.data;

  const [data, setData] = useState(sData ? sData : null);
  const [isSubmit, setisSubmited] = useState(false);
  function getView() {
    axiosInstance
      .get(`/renewals/${renewalViewId}`)
      .then((res) => {
        setData(res.data?.data);
        setisSubmited(res.data?.data?.isSubmited === true);
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  useEffect(() => {
    // if (!sData) {
    getView();
    // }
  }, [renewalViewId]);

  const pageIndex = location.state?.pageIndex;
  const searchQuery = location.state?.searchQuery;
  const [percentOpen, setPercentOpen] = useState(false);

  const [filePathList, setFilePathList] = useState([]);
  useEffect(() => {
    if (
      data?.attachments !== null &&
      data?.attachments !== "None" &&
      data?.attachments !== "[]"
    ) {
      setFilePathList(data?.attachments?.length > 0 ? data?.attachments : []);
    }
  }, [data]);

  const [expandedIndex, setExpandedIndex] = useState(null);

  const handleToggle = (index) => {
    setExpandedIndex(index === expandedIndex ? null : index);
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      clientDetails: { name: "", address: "" },
      inspectionDetails: { date: "", inspector: "" },
      serviceDetails: { serviceType: "", isUrgent: false },
      observation: { notes: "" },
    },
    validationSchema: yup.object({}),
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: (values) => {
      console.log("Submitting all data", values);
    },
  });
  const [showPdfComponent, setShowPdfComponent] = useState(false);

  const handlePdfIconClick = () => {
    setShowPdfComponent(true);
  };
  const downloadPDF = async () => {
    try {
      const response = await axiosInstance.get(
        `/surveyInspectionForm/generate-report/${renewalViewId}`,
        {
          responseType: "blob", // Important to specify the response type as blob
        }
      );

      // Create a Blob from the response
      const pdfBlob = new Blob([response.data], { type: "application/pdf" });

      // Create a link element
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(pdfBlob);
      link.download = `${data.ref}.pdf`; // The filename you want for the downloaded file

      // Append the link to the body (required for Firefox)
      document.body.appendChild(link);

      // Programmatically click the link to trigger the download
      link.click();

      // Clean up and remove the link
      link.parentNode.removeChild(link);
    } catch (error) {
      console.error("Error downloading the PDF:", error);
    }
  };
  const [viewPDF, setViewPDF] = useState(null);
  const [pdfLoading, setPdfLoading] = useState(false);

  const ViewPDF = async () => {
    setPdfLoading(true);
    try {
      const response = await axiosInstance.get(
        `/surveyInspectionForm/generate-report/${renewalViewId}`,
        {
          responseType: "blob", // Important to specify the response type as blob
        }
      );

      // Create a Blob from the response
      const pdfBlob = new Blob([response.data], { type: "application/pdf" });

      // Create a link element
      let Viewlink = window.URL.createObjectURL(pdfBlob);
      setViewPDF(Viewlink);
      setPdfLoading(false);
    } catch (error) {
      console.error("Error downloading the PDF:", error);
      setPdfLoading(false);
    }
  };

  useEffect(() => {
    ViewPDF();
  }, [renewalViewId, data]);

  const [pdfAvailable, setPdfAvailable] = useState(false);

  const getpdf = () => {
    axiosInstance
      .get(`/surveyInspectionForm/get-report/${renewalViewId}`)
      .then((res) => {
        if (res.data?.data === true) {
          // setPdfAvailable(true);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    getpdf();
  }, []);

  const id = renewalViewId;
  const getUrl = `/survey-report/get-status`;
  const putUrl = `/survey-report/edit-status`;
  const statusUrl = "/survey-report/all-status";

  const hasSidebarContent =
    GetAccess("approvals") ||
    GetAccess("client_details") ||
    GetAccess("comments");
  // pdfAvailable;

  return (
     <div className="w-full h-full py-2 px-4 ">
      <div className="sm:flex justify-between ">
      <Breadcrumb
                           items={[
                            //  { name: "Contacts" },
                             {
                                name: "Renewal",
              link: "/Contract-management/renewal",
         
                              
                             },
                 
                             { name: "View" },
                           ]}
                         />
        <div className=" flex gap-2 justify-end">
          <Link
            to={`/Contract-management/renewal`}
            state={{
              currentPage: pageIndex,
              searchQuery: searchQuery != "" ? searchQuery : "",
            }}
          >
            <BackButton link={true} />
          </Link>
          {GetAccess("consultants_edit")&&
          <Link
            to={`/Contract-management/renewal/edit/${renewalViewId}`}
            state={{
              data: data,
              from: `/Contract-management/renewal/view/${renewalViewId}`,
            }}
          >
            <EditButton height="8" />
          </Link>}
          
        </div>
      </div>

      <div className="w-full mx-auto h-[calc(100vh-160px)] drop-shadow-lg  mt-4 overflow-y-auto  md:flex gap-x-2 text-[#111537]">
        <div className="md:w-[60%] lg:w-[70%]  bg-white rounded-lg drop-shadow-lg py-1 overflow-hidden ">
          <div className="sm:w-[98%]  bg-white px-2 mx-2 border border-gray py-2 rounded-lg sm:flex justify-between items-center  z-10">
            <div className="grid  items-center ">
              <div className="flex text-[14px] mb-1 text-[#111537] font-semibold w-[100%]">
                {/* <p className="flex">Survey:</p> */}
                <p>{data?.refNumber || "None"}</p>
              </div>
         <p className="text-xs text-[#111537]"> Created By : {data?.createdByName || 'None'}</p>
             
            </div>

           

            <div className=" flex items-center mt-2 sm:mt-0  overflow-hidden rounded-full text-[10px] 2xl:text-xs  ">
              <div className="  p-2 h-6  bg-white  rounded-s-full text-xs flex items-center border border-textColor-main">
                Status{" "}
              </div>
              <div className="  p-2 h-6  bg-textColor-main text-white text-xs  rounded-e-full flex items-center">
                {data?.status || "-"}
              </div>
            </div>
          </div>

          <div className="h-[calc(100vh-200px)] overflow-y-auto p-2 pb-8 ">
            <div className=" w-full flex flex-wrap  px-2 border border-gary mt-2  rounded-lg ">
            
              <div className=" w-full sm:grid grid-cols-2 gap-x-8 mt-3">
               
                
                
                <div className="w-full flex px-2">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  Current Value
                  </p>
                  <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                    : <NuAmount value={data?.currentValue}/>
                  </p>
                </div>
                <div className="w-full flex px-2">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                  Proposed Value
                  </p>
                  <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                    : <NuAmount value={data?.proposedValue}/>
                  </p>
                </div>
               
                <div className="w-full flex px-2">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                    Current End Date
                  </p>
                  <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                    :{" "}
                    {data?.currentEndDate ? (
                      <NuDate
                        value={data?.currentEndDate}
                        format="DD-MMM-YYYY"
                      />
                    ) : (
                      "N/A"
                    )}
                  </p>
                </div>
                 <div className="w-full flex px-2">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                     Proposed End Date
                  </p>
                  <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                    :{" "}
                    {data?.proposedEndDate ? (
                      <NuDate
                        value={data?.proposedEndDate}
                        format="DD-MMM-YYYY"
                      />
                    ) : (
                      "N/A"
                    )}
                  </p>
                </div>
               
                <div className="w-full flex px-2">
                  <p className="w-1/3 py-2 text-xs font-medium text-[#111537]">
                    Days to Expire
                  </p>
                   <p className="w-[65%] py-2 text-xs font-medium text-[#606279]">
                    : {data?.daysToExpire}
                  </p>
                </div>
              </div>
            </div>
            <div className='sm:flex gap-4 mt-4'>
            {/* <div className="sm:w-[50%]">
  <p className="text-xs font-medium text-[#111537] p-1">Address</p>

  <div className="border border-gray h-28 overflow-y-scroll rounded-lg">
   
  <div className="text-xs p-2 leading-snug">
  <p>
    {[data?.address1, data?.address2].filter(Boolean).join(', ')}
  </p>
  <p>
    {[data?.city, data?.state, data?.postalCode, data?.country]
      .filter(Boolean)
      .join(', ')}
  </p>
</div>


    
  </div>
</div> */}
            <div className="sm:w-[50%] ">
               <p className=" p-1 text-xs font-medium text-[#111537]">
                 Attachement
               </p>
               <div className=" border border-gary  overflow-y-scroll h-28 rounded-lg p-2">
                
                 <div className="w-full flex gap-2 flex-wrap ">
                   {data?.attachments &&
                     filePathList.map((imgs, idx) => {
                       console.log("img", imgs);
                       return (
                         <FilesView fileView={imgs} key={idx} />
                       );
                     })}
                 </div>
               </div>
             </div>
              </div>
           


          </div>
        </div>
         {(GetAccess("approvals") ||
          GetAccess("client_details") ||
          GetAccess("comments") ||
          isSubmit) && (
          <div className="md:w-[30%] bg-white rounded-lg drop-shadow-lg py-1 mt-3 md:mt-0">
            <div className="h-[98%] overflow-y-scroll p-2 ">
              {GetAccess("approvals") && isSubmit && (
                <ApprovalComponent
                  id={id}
                  getUrl={getUrl}
                  putUrl={putUrl}
                  statusUrl={statusUrl}
                  refSetData={setData}
                  data={data}
                  type={"Survey"}
                  preUrlName={"survey-report"}
                />
              )}
              {GetAccess("client_details") && (
                <div className="w-full grid  border border-gary mt-2   rounded-lg">
                  <div className="bg-baseColor-primary  p-2 rounded-t-lg">
                    <p className="text-xs text-white font-medium">
                      Client Detail
                    </p>
                  </div>
                  {/* <p className="text-xs text-[#111537] font-medium">Customer Detail</p> */}

                  <div className="w-full flex px-2 justify-between">
                    <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                      Name
                    </p>
                    <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                      : {data?.clientName}
                    </p>
                  </div>
                  <div className="w-full flex px-2 justify-between">
                    <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                      {" "}
                      Reference
                    </p>
                    <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                      {" "}
                      : {data?.clientRefNumber}
                    </p>
                  </div>

                   <div className="w-full flex px-2 justify-between">
                    <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                      {" "}
                      Contract
                    </p>
                    <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                      {" "}
                      : {data?.contractRefNumber}
                    </p>
                  </div>
                </div>
              )}

              <div className="w-full grid  border border-gary mt-4  rounded-lg ">
                <p className="text-xs text-white font-medium bg-baseColor-primary  p-2 rounded-t-lg">
                  Report{" "}
                </p>
                <div className=" w-full flex flex-wrap overflow-y-scroll h-16">
                  <div
                    onClick={handlePdfIconClick}
                    className="cursor-pointer m-1 w-auto h-[25px] flex items-center  justify-between  rounded p-[2px] border "
                  >
                    <svg
                      width="20"
                      height="20"
                      className="fill-current text-baseColor-primary"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 512 512"
                    >
                      <path d="M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-208 0c-35.3 0-64 28.7-64 64l0 144-48 0c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm96-80l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96 16 0zm80-112c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-64z" />
                    </svg>
                    <p className=" w-auto  text-[9px]">{data?.refNumber}</p>
                  </div>
                </div>
              </div>

              {/* {GetAccess("comments") &&(
            <div className="w-full h-auto flex  border border-gary mt-4 overflow-hidden rounded-lg">
              <CommonComments
                visible={true}
                title="Comments"
                mainId={data?.prId}
                addurl={"/pr-comments/new-comment"}
                geturl={`/pr-comments/by-PR/${data?.prId}`}
              />
            </div>
             )} */}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default ViewRenewal;
